import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineArrowRight } from 'react-icons/hi2';

const InsightsPage = () => {
  const insights = [
    {
      img: '/images/ai-solutions-hero.png',
      tag: 'AI Strategy',
      title: 'The Enterprise Guide to RAG Architecture in 2026',
      desc: 'A comprehensive guide to implementing Retrieval-Augmented Generation in production environments with security and governance.',
      date: 'March 15, 2026',
      readTime: '8 min read',
    },
    {
      img: '/images/hero-architecture.png',
      tag: 'MLOps',
      title: 'Building Robust MLOps Pipelines for Enterprise AI',
      desc: 'How to implement automated model training, evaluation, and deployment pipelines that scale with your AI ambitions.',
      date: 'March 10, 2026',
      readTime: '12 min read',
    },
    {
      img: '/images/enterprise-architecture.png',
      tag: 'Data Engineering',
      title: 'Data Platform Modernization: From Legacy to AI-Ready',
      desc: 'Steps to transform your data infrastructure into a modern, AI-ready platform that supports real-time analytics and ML workloads.',
      date: 'March 5, 2026',
      readTime: '10 min read',
    },
    {
      img: '/images/case-study-reporting.png',
      tag: 'GenAI',
      title: 'LLM Evaluation Frameworks: What Enterprises Need to Know',
      desc: 'A deep dive into evaluation methodologies for large language models, including hallucination detection and bias assessment.',
      date: 'February 28, 2026',
      readTime: '15 min read',
    },
    {
      img: '/images/case-study-search.png',
      tag: 'Vector Search',
      title: 'Vector Databases in Production: Lessons Learned',
      desc: 'Practical insights from deploying vector search at scale, including index optimization, hybrid search, and cost management.',
      date: 'February 20, 2026',
      readTime: '9 min read',
    },
    {
      img: '/images/case-study-reconciliation.png',
      tag: 'Governance',
      title: 'AI Governance Frameworks for Regulated Industries',
      desc: 'How to implement responsible AI practices in highly regulated sectors like finance, healthcare, and government.',
      date: 'February 15, 2026',
      readTime: '11 min read',
    },
  ];

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <div className="hero-text">
              <div className="section-label">Knowledge Hub</div>
              <h1>Insights</h1>
              <p>Explore our latest thinking on enterprise AI, data engineering, and digital transformation.</p>
            </div>
          </div>
        </div>
        <div className="hero-image-wrapper">
          <img
            src="/images/insights-hero.png"
            alt="Enterprise AI Intelligence Network & Knowledge Hub"
          />
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <div className="insights-grid">
            {insights.map((item, i) => (
              <div className={`insight-card fade-in-up-delay${(i % 4) + 1}`} key={i}>
                <img src={item.img} alt={item.title} className="insight-image" />
                <div className="insight-content">
                  <div className="insight-tag">{item.tag}</div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                  <div className="insight-meta">{item.date} · {item.readTime}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Want to stay ahead in enterprise AI?</h2>
            <p>Subscribe to our newsletter for the latest insights and best practices.</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn-primary">Subscribe Now <HiOutlineArrowRight /></Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default InsightsPage;
